import { useQuery } from '@tanstack/react-query'
import { PaytrieAPI } from '@paytrie/client'

export const useWidgetConfig = () =>
  useQuery({
    queryKey: ['v2', 'widget-config'],
    queryFn: async () => {
      const res = await PaytrieAPI.getWidgetConfig()
      if (res.status !== 200) {
        throw new Error(`Failed to load widget config (status ${res.status})`)
      }
      return res.data.data
    },
    staleTime: Infinity,
    retry: 2,
  })
